import CustomErrorPage from "@app/components/pages/CustomErrorPage";
import { LogIn01 } from "@dust-tt/sparkle";
import { useTranslation } from "react-i18next";

export default function Custom404() {
  const { t } = useTranslation();
  return (
    <CustomErrorPage
      title={t("pages.custom404Title", "404: Page not found")}
      description={t(
        "pages.custom404Description",
        "Looks like this page took an unscheduled coffee break."
      )}
      href="/"
      label={t("pages.backToHomepage", "Back to homepage")}
      icon={LogIn01}
    />
  );
}
